import type { TrigKey } from './keys';

export const de: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Mathematik · Trigonometrie',
  'panel.experiment': 'Experiment',
  'panel.params': 'Parameter',
  'panel.scene': 'Wähle ein Experiment',
  'experiment.right-triangle.label': 'Rechtwinkliges Dreieck',
  'experiment.unit-circle.label': 'Einheitskreis',
  'experiment.wave-studio.label': 'Wellen-Studio',
  'experiment.identity-playground.label': 'Identitäten',
  'experiment.triangle-solver.label': 'Dreieckslöser',
  'experiment.circular-polar.label': 'Kreis & Polar',
  'hint.line1': 'Ziehe Punkte und bewege Schieber.',
  'hint.line2': 'Lehrinhalt steckt in der Geometrie, nicht im Text.',
  'rt.angle.a': 'Winkel A',
  'rt.angle.b': 'Winkel B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Bogenmaß',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': 'Auf 30°/45°/60° einrasten',
  'uc.units': 'Einheiten',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'ASTC anzeigen',
  'uc.snap.common': 'Auf gängige Winkel einrasten',
  'uc.angle.value': '∠',
  'uc.units.deg': 'Grad',
  'uc.units.rad': 'rad',
  'uc.units.both': 'Grad+rad',
  'ws.fn': 'Funktion',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — Amplitude',
  'ws.frequency': 'B — Frequenz',
  'ws.phase': 'C — Phasenverschiebung',
  'ws.shift': 'D — Vertikale Verschiebung',
  'ws.rform.toggle': 'R-Form-Herleitung',
  'ws.rform.a': 'a (sin-Koeff.)',
  'ws.rform.b': 'b (cos-Koeff.)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Zurücksetzen',
  'ws.base': 'Grundkurve anzeigen',
  'ip.id.pythagorean': 'Pythagoräisch',
  'ip.id.reciprocal': 'Kehrwert',
  'ip.id.quotient': 'Quotient',
  'ip.id.sum': 'Summe',
  'ip.id.difference': 'Differenz',
  'ip.id.double': 'Doppelwinkel',
  'ip.id.half': 'Halbwinkel',
  'ip.play': 'Abspielen',
  'ip.pause': 'Pause',
  'ip.step': 'Schritt',
  'ip.reset': 'Zurücksetzen',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'Kommt in v2 — dieser Beweis braucht eine ausführlichere Konstruktion.',
  'ts.area': 'Fläche',
  'ts.sineRule': 'Sinussatz',
  'ts.cosineRule': 'Kosinussatz',
  'ts.ambiguous.toggle': 'Geister-Dreieck bei Mehrdeutigkeit',
  'ts.reset': 'Auf gleichseitig zurück',
  'ts.snap.integers': 'Auf Ganzzahlen einrasten',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Seiten',
  'ts.section.angles': 'Winkel',
  'ts.section.sineRule': 'Sinussatz',
  'ts.section.cosineRule': 'Kosinussatz',
  'ts.section.area': 'Fläche',
  'cp.omega': 'Winkelgeschwindigkeit',
  'cp.plot.y': 'y plotten (sin)',
  'cp.plot.x': 'x plotten (cos)',
  'cp.polar.label': 'Polarfigur',
  'cp.polar.circle': 'Kreis (r = 1)',
  'cp.polar.rose': 'Rose (r = sin 3θ)',
  'cp.polar.cardioid': 'Kardioide (r = 1 + cos θ)',
  'cp.polar.limacon': 'Limaçon (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Kleinwinkelnäherung (sin x ≈ x)',
  'cp.play': 'Abspielen',
  'cp.pause': 'Pause',
  'cp.reset': 'Zurücksetzen',
  'cp.step': 'Schritt π/12',
};
